import _ from "lodash-es";
import Path from "@/lib/common/path";
import Config from "@/config/config";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export default class Count extends Model {
  name = "";
  remain = 0;
  expireTime = "";

  static list(): Promise<Count[]> {
    return request
      .post(Path.join(Config.accountUrl, "/", "api/stock/count"))
      .then(resp => {
        const data = resp.data.data;
        const counts = new Array<Count>();
        _.forEach(data.list, item => {
          const c = new Count().assign(item);
          counts.push(c);
        });
        return counts;
      });
  }
}
